// extracted by mini-css-extract-plugin
export default {"productGallery":"YK-z","inQuickShop":"ZK-z"};